import React from 'react';
import { Palette } from 'lucide-react';
import CtaUrlBlock from './CtaUrlBlock.jsx';

const CarouselResultEntry = ({ entry, w = (o) => `rgba(255,255,255,${o})`, t = {} }) => {
  const data = entry.results;
  if (!data) return null;
  const c = data.content || {};
  const slides = c.slides || [];
  const companionPost = c.hook || null;
  const hashtags = c.hashtags || [];
  const color = entry.modeConfig?.color || '#6366F1';
  return (
    <div>
      {slides.map((slide, i) => (
        <div key={i} style={{ marginBottom: '10px', padding: '14px 16px', background: w(0.03), borderRadius: '10px', border: `1px solid ${w(0.06)}` }}>
          <div style={{ fontSize: '10px', fontFamily: "'JetBrains Mono', monospace", color: t.textMuted || '#555568', letterSpacing: '1px', marginBottom: '8px' }}>SLIDE {slide.number} / {slides.length}</div>
          <div style={{ fontSize: '15px', fontWeight: 600, color, marginBottom: '6px' }}>{slide.headline}</div>
          <div style={{ fontSize: '13px', lineHeight: 1.6, marginBottom: '8px', color: t.text }}>{slide.body}</div>
          <div style={{ fontSize: '11px', color: t.textMuted || '#7a7a8e', display: 'flex', alignItems: 'center', gap: '6px' }}><Palette size={12} />{slide.visual_cue || slide.visualCue}</div>
        </div>
      ))}
      {companionPost && (
        <div style={{ marginTop: '18px', padding: '16px', borderRadius: '10px', background: `${color}08`, border: `1px solid ${color}20` }}>
          <label style={{ fontSize: '10px', fontFamily: "'JetBrains Mono', monospace", color, letterSpacing: '1px', textTransform: 'uppercase', display: 'block', marginBottom: '8px', fontWeight: 700 }}>POST DI ACCOMPAGNAMENTO</label>
          <div style={{ padding: '14px 16px', background: w(0.05), borderRadius: '8px', borderLeft: `3px solid ${color}`, fontSize: '14px', lineHeight: 1.7, whiteSpace: 'pre-wrap', color: t.text }}>{companionPost}</div>
          <CtaUrlBlock entry={entry} />
        </div>
      )}
      {hashtags.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '12px' }}>
          {hashtags.map((tag, i) => <span key={i} style={{ padding: '3px 10px', borderRadius: '20px', background: `${color}15`, color, fontSize: '12px' }}>
            {tag.startsWith('#') ? tag : `#${tag}`}
          </span>)}
        </div>
      )}
    </div>
  );
};
export default CarouselResultEntry;
